import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Notifications from "vue-notification";

Vue.config.productionTip = false;
// Uses vue-notification library
Vue.use(Notifications);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
